import React from 'react';
import { DeleteOutlined } from '@ant-design/icons';
import Avatar from 'antd/lib/avatar/avatar';
import { AuthService } from '../../services';
import { TimeFormatter } from '../../utils/timeParser';
import MessageWrapper from './style';
import { getNickName } from '../../utils/commonUtils';

const Message = (props) => {
  const { children, message, onDeleteNote } = props;
  const userData = AuthService.getUserData();
  const userId = userData.id;

  const time = () => {
    const formatted = TimeFormatter(message.created_at);
    return `${formatted.additional}, ${formatted.hour}:${formatted.min}`;
  };
  const messageSender = () => {
    if (userId === message?.user?.id) {
      return 'You';
    }
    return message?.user?.name;
  };
  return (
    <MessageWrapper>
      <div className="component_message_header">
        <Avatar>{getNickName(message?.user?.name)}</Avatar>
        <span className="font-paragraph_medium black1">{messageSender()}</span>
        <span className="font-caption black1">{time()}</span>
        {userId === message?.user?.id && (
          <DeleteOutlined
            onClick={() => {
              onDeleteNote(message.id);
            }}
          />
        )}
      </div>
      <div className="font-subtitle2 black1">{children}</div>
    </MessageWrapper>
  );
};

export default Message;
